const RESET_ORDER_STATE = 'APP/RESET_ORDER_STATE';
const RESET_ORDERS_STATE = 'APP/RESET_ORDERS_STATE';

const isThisObject = (key, state = {}, action) => {
  const keyValue =
    action && action.payload && action.payload[key]
      ? action.payload[key]
      : false;
  return !(keyValue && state[key] !== keyValue);
};

const removeKeyFrom = {
  array: (arr, key) => {
    const newArr = [...arr];
    if (newArr.indexOf(key) >= 0) {
      newArr.splice(newArr.indexOf(key), 1);
    }
    return [...newArr];
  },
  object: (obj, key) => {
    const newObj = { ...obj };
    delete newObj[key];
    return { ...newObj };
  },
};

const reducerItem = (state, action, { handlers, key, forAll }) =>
  (!!state && !forAll && !isThisObject(key, state, action)) ||
  !handlers[action.type]
    ? state
    : handlers[action.type](state, action);

const reduceExtrasWithExcluyents = (extra, state) => {
  const REDUCE_BY_EXTRA = {
    REMOVE_LIFTGATE_SIDE_LOAD: (currentState) => [
      ...currentState.filter(
        (extraKey) => extraKey !== 'LIFTGATE' && extraKey !== 'SIDE_LOAD'
      ),
    ],
    LIFTGATE: (currentState) => [
      ...currentState.filter((extraKey) => extraKey !== 'SIDE_LOAD'),
      extra,
    ],
    SIDE_LOAD: (currentState) => [
      ...currentState.filter((extraKey) => extraKey !== 'LIFTGATE'),
      extra,
    ],
  };

  const addOrRemoveExtra = (key, currentState) =>
    currentState.includes(key)
      ? [...currentState.filter((extraKey) => extraKey !== key)]
      : [...currentState, key];

  return REDUCE_BY_EXTRA[extra]
    ? REDUCE_BY_EXTRA[extra](state)
    : addOrRemoveExtra(extra, state);
};

export default {
  RESET_ORDER_STATE,
  RESET_ORDERS_STATE,
  isThisObject,
  removeKeyFrom,
  reducerItem,
  reduceExtrasWithExcluyents,
};
